import { weightConstants } from "../../constants";

export function weight(state = {}, action) {
  switch (action.type) {
    // get all
    case weightConstants.GET_ALL_REQUEST:
      return {
        loading: true,
      };
    case weightConstants.GET_ALL_SUCCESS:
      return {
        items: action.items,
      };
    case weightConstants.GET_ALL_FAILURE:
      return {
        error: action.error,
      };

    // add
    case weightConstants.ADD_REQUEST:
      return {
        loading: true,
      };
    case weightConstants.ADD_SUCCESS:
      return {
        parameter: action.parameter,
      };
    case weightConstants.ADD_FAILURE:
      return {
        error: action.error,
      };

    // update
    case weightConstants.UPDATE_REQUEST:
      return {
        loading: true,
      };
    case weightConstants.UPDATE_SUCCESS:
      return {
        parameter: action.parameter,
      };
    case weightConstants.UPDATE_FAILURE:
      return {
        error: action.error,
      };

    // delete
    case weightConstants.DELETE_REQUEST:
      return {
        loading: true,
      };
    case weightConstants.DELETE_SUCCESS:
      return {
        parameter: action.parameter,
      };
    case weightConstants.DELETE_FAILURE:
      return {
        error: action.error,
      };

    // clear
    case weightConstants.CLEAR:
      return {};

    default:
      return state;
  }
}
